// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"7b7242e6","710":"88bac93e"}[chunkId] + ".chunk.js";
};